import Tools from '../Tools/Tools';
/**
 * Třída, která registuje různé listenery.
 */
class Listeners {
	constructor() {
		this.registerListeners();
		this.initClosableElms();
	}

	// Slouží k otevírání/zavírání elementů s třídou .js-closableEl
	initClosableElms() {
		const closableElms = Array.from(document.querySelectorAll('.js-closableEl'));

		closableElms.forEach((el) => {
			const closeBtn = el.querySelector('.js-closeEl');

			if (!closeBtn) {
				return;
			}

			closeBtn.addEventListener('click', () => {
				el.classList.remove('is-visible');
				el.classList.add('is-hidden');
			});
		});

		const openBtns = Array.from(document.querySelectorAll('.js-openEl'));

		openBtns.forEach((btn) => {
			btn.addEventListener('click', () => {
				const el = document.querySelector(`#${btn.dataset.id}`);

				if (!el) {
					return;
				}

				closableElms.forEach((div) => {
					div.classList.remove('is-visible');
					div.classList.add('is-hidden');
				});

				el.classList.add('is-visible');
				el.classList.remove('is-hidden');
			});
		});
	}

	/**
	 * Registruje listenery.
	 */
	registerListeners() {
		// Slouží pro překlikávání tabů. Předpokladem je element obsahující třídu 'TabNav' a jeho potomci
		// mají data-id, které odpovídá obsahu s daným data-id.
		Array.from(document.getElementsByClassName('TabNav')).forEach((el) =>
			el.addEventListener('click', (e) => {
				if (e.target.getAttribute('data-id') && e.target.parentElement.classList.contains('TabNav')) {
					Array.from(e.target.parentElement.children).forEach((tab) => {
						// Kliknutý tab, který bude zvýraznět a jeho obsah zobrazen.
						if (tab === e.target) {
							tab.classList.add('is-active');

							document.getElementById(tab.getAttribute('data-id')).classList.add('is-active');
						} else if (tab.classList.contains('is-active')) {
							// Předchozí vybraný tab, který bude schován.
							tab.classList.remove('is-active');

							document.getElementById(tab.getAttribute('data-id')).classList.remove('is-active');
						}
					});
				}
			}),
		);

		// Slouží k otevírání/zavírání sekcí ve formulářích.
		Array.from(document.getElementsByClassName('Form-section-heading')).forEach((opener) => {
			opener.addEventListener('click', (e) => {
				if (e.target.classList.contains('Form-section-title') || e.target.classList.contains('Form-section-opener')) {
					const section = Tools.getParentByClass(e.target, 'Form-section-heading');

					const [opener_] = section.getElementsByClassName('Form-section-opener');

					// Toggle section content
					section.nextElementSibling.classList.toggle('is-open');
					opener_.classList.toggle('is-open');
				}
			});
		});
	}
}

export default Listeners;
